import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Divider, Stack, Typography, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { CenteredFlexBox } from '../../../../Components/FlexBox';

const SystemParametersListItems = function SystemParametersListItems({
  settings,
  onClick,
  searchedValue,
}) {
  const intl = useIntl();

  const openEditDialogHandler = (setting) => {
    onClick(setting);
  };

  const filteredSettings =
    settings?.filter(
      (s) =>
        !searchedValue ||
        s.settingName?.toLowerCase()?.includes(searchedValue?.toLowerCase())
    ) ?? [];

  return (
    <div>
      <CenteredFlexBox
        sx={{
          backgroundColor: 'background.paper',
          padding: '16px',
          position: 'sticky',
          top: 0,
          zIndex: 1,
        }}
      >
        <Typography variant="h6" sx={{ width: '25%' }}>
          {intl.messages.NAME}
        </Typography>
        <Typography variant="h6" sx={{ width: '25%' }}>
          {intl.messages.VALUE}
        </Typography>
        <Typography variant="h6" sx={{ width: '50%' }}>
          {intl.messages.DESCRIPTION}
        </Typography>
      </CenteredFlexBox>

      <Stack divider={<Divider />}>
        {filteredSettings.map((setting) => (
          <CenteredFlexBox key={setting.settingName} padding="16px" gap="30px">
            <Typography variant="body1" sx={{ width: '25%' }}>
              {setting.settingName}
            </Typography>
            <Typography variant="body1" sx={{ width: '25%' }}>
              {setting.settingValue}
            </Typography>
            <Typography variant="body1" sx={{ width: '50%' }}>
              {setting.description}
            </Typography>
            <Tooltip title={intl.messages.EDIT_SYSTEM_PARAMETER}>
              <IconButton
                key={settings.settingName}
                onClick={() => openEditDialogHandler(setting)}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </CenteredFlexBox>
        ))}
      </Stack>
    </div>
  );
};

SystemParametersListItems.propTypes = {
  settings: PropTypes.array,
  onClick: PropTypes.func,
  searchedValue: PropTypes.object,
};

export default SystemParametersListItems;
